var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "site-footer" }, [
      _c("div", { staticClass: "text-left float-left" }, [
        _c("a", { attrs: { href: "mailto:kozpont@itzen.hu" } }, [
          _c("i", { staticClass: "icon-im icon-im-question" }),
          _vm._v("\n          Segítségkérés\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-right float-right" }, [
        _vm._v("\n      Készítette az\n    "),
        _c("a", { attrs: { href: "https://itzen.hu/", target: "_blank" } }, [
          _vm._v("\n      ITZen\n    ")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }